import React from 'react';

import Tab from '../components/Tab';
import Dropdown from '../components/Dropdown';
import RoomRadio from './Inputs/RoomRadio';

const Room = () => {
  return(
    <div className='vesta-dropdown-filter-container'>
      <Tab name='Pièces' tab='room' />

      <Dropdown title='Combien de pièces souhaitez-vous ?' tab='room'>
        <RoomRadio />
      </Dropdown>
    </div>
  )
};

export default Room;
